import {Component, OnInit} from '@angular/core';
import {MenuButtonsPageComponent} from '../../shared/components/menu-buttons-page/menu-buttons-page.component';
import {HouseRulesService} from '../../core/api/house-rules.service';
import {HouseRule, HouseRules} from '../../shared/models/house-rules.model';
import {LangService} from '../../core/services/lang.service';
import {Router} from '@angular/router';
import { getHouseRules } from '../../shared/models/house-rules.model';

@Component({
  selector: 'app-house-rules',
  templateUrl: './house-rules.component.html',
  imports: [MenuButtonsPageComponent],
})
export class HouseRulesComponent implements OnInit {

  backgroundImage = '/images/house-rules.png';

  topActions: TopAction[] = [];

  constructor(private router: Router, private houseRulesService: HouseRulesService, private langService: LangService) {
  }

  ngOnInit(): void {
    this.loadHouseRules();
  }

  private loadHouseRules() {
    this.houseRulesService.getHouseRules().subscribe({
      next: (houseRules: HouseRules
      ) => {
        const rules = getHouseRules(houseRules);
        this.topActions = rules.map((rule: HouseRule) => ({
          id: rule.title,
          label: rule.title,
          href: `/house-rules/${rule.id}`,
        }));
      },
      error: (error) => {
        console.error('Error al obtener las reglas de la casa:', error);
      }
    });
  }

  onActionClick(action: TopAction) {
    if (action.href) {
      const ruleId = action.href.split('/').pop();
      if (ruleId) {
        this.router.navigate(['/house-rules', ruleId]);
      }
    }
  }
}
